/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

///////////////////////////////////////////////////////////
/////////////////// BAND MATH /////////////////////////////
///////////////////////////////////////////////////////////

import * as Blockly from 'blockly/core';
import 'blockly/python';
import { getCurrentSat, getBandArray } from '../dataset';

///////////////////////////////////////////////////////////
//////////////////////// INPUT ////////////////////////////
///////////////////////////////////////////////////////////

Blockly.Blocks['analyse_band_input'] = {
    init: function () {
        const generateBandOptions = (function (self) {
            return function () {
                let sat = getCurrentSat(self);
                if ((sat !== null) && (sat !== '')) {
                    return getBandArray[sat]();
                } else {
                    return getBandArray['l8']();
                }
            }
        })(this);

        this.appendDummyInput("Band")
            .appendField(new Blockly.FieldDropdown(generateBandOptions), "band");
        this.setPreviousStatement(false, 'band_math_expression');
        this.setOutput(true, 'band_math_expression');
        this.setStyle('bandMath');
        this.setTooltip(Blockly.Msg.BAND_INPUT_TOOLTIP);
        this.setHelpUrl("");
    }
}